import { MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { OuiBanner } from 'omnium-ui/banner';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule, OuiDialogService } from 'omnium-ui/dialog';
import { OuiFatButton } from 'omnium-ui/fat-button';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoading } from 'omnium-ui/loading';
import { RenouvellementService } from '../../../_shared/services/renouvellement/renouvellement.service';
import { RenouvellementAcceptedDialogComponent } from './renouvellement-accepted-dialog/renouvellement-accepted-dialog.component';
import { RenouvellementRefusedDialogComponent } from './renouvellement-refused-dialog/renouvellement-refused-dialog.component';
import { OuiSnackbarService } from 'omnium-ui/snackbar';

@Component({
  selector: 'app-renouvellement-dialog',
  standalone: true,
  imports: [
    OuiDialogModule,
    OuiFatButton,
    OuiButton,
    OuiLoading,
    OuiBanner,
    OuiIconModule,
  ],
  templateUrl: './renouvellement-dialog.component.html',
  styleUrl: './renouvellement-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenouvellementDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RenouvellementDialogComponent>);
  private readonly renouvellementService = inject(RenouvellementService);
  private readonly dialogService = inject(OuiDialogService);
  private readonly snackbarService = inject(OuiSnackbarService);

  readonly isLoading = signal<boolean>(false);

  readonly bannerText =
    "Sans réponse de votre part d'ici cette date, la collaboration sera considérée comme terminée. Vos conventions et contrats seront alors résiliés de plein droit à votre seule initiative, conformément aux engagements souscrits.";

  async renouvellementAccept() {
    try {
      this.isLoading.set(true);
      await this.renouvellementService.acceptRenouvellement();
      this.dialogRef.close();
      this.dialogService.openDialog(RenouvellementAcceptedDialogComponent);
    } catch (error) {
      console.error(error);
      this.snackbarService.open(
        'Une erreur est survenue durant la validation du renouvellement.',
        'error'
      );
    }

    this.isLoading.set(false);
  }

  async renouvellementRefuse() {
    try {
      this.isLoading.set(true);
      await this.renouvellementService.refuseRenouvellement();
      this.dialogRef.close();
      this.dialogService.openDialog(RenouvellementRefusedDialogComponent);
    } catch (error) {
      console.error(error);
      this.snackbarService.open(
        'Une erreur est survenue durant le refus du renouvellement.',
        'error'
      );
    }

    this.isLoading.set(false);
  }
}
